import React from "react";
import { arrayOf, number, objectOf, shape, string } from "prop-types";
import styles from "./RegionEventsView.module.styl";
import RegionEventGroup from "components/regionSummary/RegionEventGroup/RegionEventGroup";

export default function RegionEventsView({ eventsList }) {
    if (Object.entries(eventsList).length === 0) {
        return (
            <p className={styles.noItems} data-test-name="region-events-no-items">
                По данным параметрам не найдено ни одного мероприятия. Пожалуйста, измените
                параметры поиска.
            </p>
        );
    }
    return (
        <div className={styles.form}>
            {Object.entries(eventsList).length > 0 && (
                <div className={styles.headingContainer} data-test-name="region_events_form">
                    <div>{}</div>
                    <div>№ в КП</div>
                    <div>Наименование мероприятия</div>
                    <div>Проводящая организация</div>
                    <div>Период проведения</div>
                    <div className={styles.participants}>
                        Количество участников
                        <div className={styles.flexContainer}>
                            <div>Заявились</div>
                            <div>С результатами</div>
                        </div>
                    </div>
                    <div>Время подачи отчёта</div>
                </div>
            )}
            {Object.entries(eventsList).map(([key, value]) => (
                <RegionEventGroup key={key} items={value} groupName={key} />
            )) ?? []}
        </div>
    );
}

RegionEventsView.propTypes = {
    eventsList: objectOf(
        arrayOf(
            shape({
                id: number,
                name: string,
                sportTypeName: string,
                status: string,
                federationName: string,
                startDate: string,
                endDate: string,
                participantsCount: number,
                participantsWithResult: number,
                kpNumber: string,
            }),
        ),
    ),
};
